import { useCallback } from 'react';
import { formatClientDate, startOfDay } from 'shared/util/datetime-fns';

interface UpdateSingleDateProps {
    startDate: Date | null;
    setStartDate: (date: Date | null) => void;
    setInputStartDate: (dateString: string) => void;
    setIsStartDateFocused: (flag: boolean) => void;
}

export const useUpdateSingleDate = ({ startDate, setStartDate, setInputStartDate, setIsStartDateFocused }: UpdateSingleDateProps) =>
    useCallback(
        (date: Date) => {
            if (date === null) {
                setStartDate(null);
                setInputStartDate('');
                setIsStartDateFocused(true);
                return;
            }

            const resetDate = startOfDay(new Date(date));
            const normalizedDate = new Date(resetDate ?? date);

            if (startDate && normalizedDate.getTime() === startDate.getTime()) {
                setStartDate(null);
                setInputStartDate('');
                setIsStartDateFocused(false);
                return;
            }

            setStartDate(normalizedDate);
            setInputStartDate(formatClientDate(normalizedDate));
            setIsStartDateFocused(true);
        },
        [startDate, setStartDate, setInputStartDate, setIsStartDateFocused],
    );
